"use client";

import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow } from "swiper/modules";
//
import { Button } from "@/components";
import { getImageURL, sanitizeHTML } from "@/lib";

let ANIM_DURATION = 300;

export const HomePageSolution = ({ data = {}, slug = "solution" }) => {
    let { description, image, list, title } = data;

    if (list?.length < 4) {
        list = [...list, ...list, ...list];
    } else if (list?.length < 8) {
        list = [...list, ...list];
    }

    const [animating, setAnimating] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [firstSlider, setFirstSlider] = useState(null);
    const [secondSlider, setSecondSlider] = useState(null);

    const options = {
        slidesPerView: "auto",
        loop: true,
        onSwiper: setFirstSlider,
        onSlideChange: (swiper) => {
            const currentIndex = swiper?.realIndex;

            setCurrentSlide(currentIndex);

            if (
                !animating &&
                secondSlider &&
                secondSlider?.realIndex !== currentIndex
            ) {
                secondSlider.slideToLoop(currentIndex);
            }
        },
    };

    const imagesSliderOptions = {
        modules: [EffectCoverflow],
        effect: "coverflow",
        centeredSlides: true,
        clickable: true,
        loop: true,
        loopAdditionalSlides: 2,
        slidesPerView: "auto",
        onSwiper: (swiper) => {
            setCurrentSlide(swiper?.realIndex);
            setSecondSlider(swiper);
        },
        onSlideChange: (swiper) => {
            const currentIndex = swiper?.realIndex;

            setCurrentSlide(currentIndex);

            if (
                !animating &&
                firstSlider &&
                firstSlider?.realIndex !== currentIndex
            ) {
                firstSlider?.slideToLoop(currentIndex);
            }
        },
        coverflowEffect: {
            rotate: 0,
            stretch: 40,
            depth: 200,
            modifier: 2.5,
            slideShadows: false,
        },
        breakpoints: {
            320: {
                coverflowEffect: {
                    rotate: 0,
                    stretch: 10,
                    depth: 180,
                    modifier: 2.5,
                    slideShadows: false,
                },
            },
            1200: {
                coverflowEffect: {
                    rotate: 0,
                    stretch: 20,
                    depth: 200,
                    modifier: 2.5,
                    slideShadows: false,
                },
            },
        },
    };

    const nextSlide = () => {
        if (firstSlider && secondSlider && !animating) {
            firstSlider.slideNext();
        }
    };

    const prevSlide = () => {
        if (firstSlider && secondSlider && !animating) {
            firstSlider.slidePrev();
        }
    };

    useEffect(() => {
        setAnimating(true);

        setTimeout(() => {
            setAnimating(false);
        }, ANIM_DURATION);
    }, [currentSlide]);

    return (
        <section className="solution__section" id={slug}>
            <div className="circle lg__circle" />
            <div className="circle sm__circle" />
            <div className="custom-container">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10 col-xl-10">
                        <div className="section_header">
                            <h3
                                className="heading text-center fs-48 fw-300"
                                dangerouslySetInnerHTML={{
                                    __html: sanitizeHTML(title),
                                }}
                            />
                            <div className="content__wrap text-center">
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: sanitizeHTML(description),
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-10 col-xl-10">
                        <div className="solution__wrapper">
                            <div className="solution__slider">
                                <Swiper {...imagesSliderOptions}>
                                    {list?.map((item, index) => (
                                        <SwiperSlide key={index}>
                                            <div className="single__item">
                                                <div className="img__wrap">
                                                    <img
                                                        className="img-fluid"
                                                        src={getImageURL(
                                                            item?.image?.src
                                                        )}
                                                        alt={item?.image?.alt}
                                                    />
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>

                            <div className="solution__content_slider">
                                <Swiper {...options}>
                                    {list?.map((item, index) => (
                                        <SwiperSlide key={index}>
                                            <div className="single__item">
                                                <div className="content__area text-center">
                                                    <h5
                                                        className="heading fs-28 fw-600 text-gradient"
                                                        dangerouslySetInnerHTML={{
                                                            __html: sanitizeHTML(item?.title),
                                                        }}
                                                    />

                                                    <div className="content__wrap text-center">
                                                        <p
                                                            dangerouslySetInnerHTML={{
                                                                __html: sanitizeHTML(item?.description),
                                                            }}
                                                        />
                                                    </div>

                                                    <Button
                                                        label="Learn More"
                                                        href={item?.link?.url}
                                                    />
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>

                            <ul className="solution__slider_btn">
                                <li
                                    className="prev-btn-solution"
                                    onClick={prevSlide}
                                    style={{
                                        cursor: "pointer",
                                    }}
                                >
                                    <svg
                                        width={87}
                                        height={87}
                                        viewBox="0 0 87 87"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect
                                            x={-0.896552}
                                            y={0.896552}
                                            width={76.2069}
                                            height={76.2069}
                                            rx="38.1034"
                                            transform="matrix(-1 0 0 1 80.7069 4.5)"
                                            stroke="#0DB02B"
                                            strokeWidth={1.7931}
                                        />
                                        <path
                                            d="M60.9824 43.0517C61.4776 43.0517 61.879 43.4531 61.879 43.9482C61.879 44.4434 61.4776 44.8448 60.9824 44.8448V43.9482V43.0517ZM25.3715 44.5822C25.0213 44.2321 25.0213 43.6644 25.3715 43.3143L31.0771 37.6087C31.4272 37.2585 31.9949 37.2585 32.345 37.6087C32.6951 37.9588 32.6951 38.5265 32.345 38.8766L27.2733 43.9482L32.345 49.0199C32.6951 49.37 32.6951 49.9377 32.345 50.2878C31.9949 50.6379 31.4272 50.6379 31.0771 50.2878L25.3715 44.5822ZM60.9824 43.9482V44.8448H26.0054V43.9482V43.0517H60.9824V43.9482Z"
                                            fill="#0DB02B"
                                        />
                                    </svg>
                                </li>

                                <li
                                    className="next-btn-solution"
                                    onClick={nextSlide}
                                    style={{
                                        cursor: "pointer",
                                    }}
                                >
                                    <svg
                                        width={87}
                                        height={87}
                                        viewBox="0 0 87 87"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect
                                            x={5.39655}
                                            y={5.39655}
                                            width={76.2069}
                                            height={76.2069}
                                            rx="38.1034"
                                            stroke="#0DB02B"
                                            strokeWidth={1.7931}
                                        />
                                        <path
                                            d="M26.0176 43.0517C25.5224 43.0517 25.121 43.4531 25.121 43.9482C25.121 44.4434 25.5224 44.8448 26.0176 44.8448V43.9482V43.0517ZM61.6285 44.5822C61.9787 44.2321 61.9787 43.6644 61.6285 43.3143L55.9229 37.6087C55.5728 37.2585 55.0051 37.2585 54.655 37.6087C54.3049 37.9588 54.3049 38.5265 54.655 38.8766L59.7267 43.9482L54.655 49.0199C54.3049 49.37 54.3049 49.9377 54.655 50.2878C55.0051 50.6379 55.5728 50.6379 55.9229 50.2878L61.6285 44.5822ZM26.0176 43.9482V44.8448H60.9946V43.9482V43.0517H26.0176V43.9482Z"
                                            fill="#0DB02B"
                                        />
                                    </svg>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
